const Regulation = () => {
  return (
    <>
      <span className='fw-600'>DISCLOSURE</span>
      <p>
        These offering materials may contain forward-looking statements and information relating to, among other things, the company, its business
        plan and strategy, and its industry. These forward-looking statements are based on the beliefs of, assumptions made by, and information
        currently available to the company’s management. When used in the offering materials, the words “estimate,” “project,” “believe,”
        “anticipate,” “intend,” “expect” and similar expressions are intended to identify forward-looking statements. These statements reflect
        management’s current views with respect to future events and are subject to risks and uncertainties that could cause the company’s actual
        results to differ materially from those contained in the forward-looking statements. Investors are cautioned not to place undue reliance on
        these forward-looking statements, which speak only as of the date on which they are made. The company does not undertake any obligation to
        revise or update these forward-looking statements to reflect events or circumstances after such date or to reflect the occurrence of
        unanticipated events.
      </p>
      <p>
        Please note investors in this offering will be clients of the issuer and not Dalmore. Dalmore’s role in the transaction is to facilitate back
        office and regulatory functions related to the Regulation A transaction. Dalmore is not providing investment advice or recommendations, or
        legal or tax advice.
      </p>
      <p>
        No money or other consideration is being solicited, and if sent in response, will not be accepted. No offer to buy the securities can be
        accepted and no part of the purchase price can be received until the offering statement filed by the company with the sec has been qualified
        by the SEC. Any such offer may be withdrawn or revoked, without obligation or commitment of any kind, at any time before notice of acceptance
        given after the date of qualification. An indication of interest involves no obligation or commitment of any kind. An offering statement
        regarding this offering has been filed with the SEC. You may obtain a copy of the preliminary offering circular that is part of that offering
        statement.
      </p>
      <p>
        An offering statement regarding this offering has been filed with the SEC. The SEC has qualified that offering statement, which only means
        that the company may make sales of the securities described by the offering statement. It does not mean that the SEC has approved, passed upon
        the merits or passed upon the accuracy or completeness of the information in the offering statement. The offering circular that is part of
        that offering statement is at: <span className='underline'>
          <a href='\"https://www.realbricks.com/offering-circular\'>https://www.realbricks.com/offering-circular</a>
          </span>
      </p>
    </>
  );
};

export default Regulation;
